'use strict';

import StaticResource from './static-resource';
import HtmlResource from './html-resource';
import IFrameResource from './iframe-resource';

export { StaticResource };
export { HtmlResource };
export { IFrameResource };

